<template>
  <div class="whole_bg">
    <div class="big_bt"> <Nav curNavId="1" pathUrl='gbzntjs' /></div>
    <div class="nr_txt">
      <div class="nr_txt_left">
        <div class="txt_left_top">
          <div class="xiao_bt">全国强筋、中筋、低筋小麦种植情况分布</div>
          <div class="left_top_dh">
            <div class="top_dh1 top_dh">强筋小麦</div>
            <div class="top_dh2 top_dh">中筋小麦</div>
            <div class="top_dh3 top_dh">低筋小麦</div>
          </div>
          <div class="left_top_txt">
            <leftBar1 />
          </div>
        </div>
        <div class="txt_left_down">
          <div class="xiao_bt">近5年全国强筋、中筋、弱筋小麦产量</div>
          <div class="left_down_txt">
            <LeftBar/>
          </div>
        </div>
      </div>
      <div class="nr_txt_mid">
        <div class="dt">
          <img src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/qqxm/dq.png">

        </div>

      </div>
      <div class="nr_txt_right">
        <div class="txt_right_top">
          <div class="xiao_bt">近5年全国强筋、中筋、弱筋面粉价格趋势图</div>
          <div class="right_nr">
            <rightLine/>
          </div>

        </div>
        <div class="txt_right_down">
          <div class="xiao_bt">近5年全国强筋、中筋、弱筋面粉供需情况图</div>
          <div class="right_nr"> <rightLine1/></div>
        </div>

      </div>
    </div>
  </div>
</template>
<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
} from "vue";

import leftBar1 from "../components/plantfx/leftPie";
import LeftBar from "../components/plantfx/LeftBar";
import rightLine from "../components/plantfx/rightLine";
import rightLine1 from "../components/plantfx/rightLine1";

import Nav from "../components/nav.vue";
const router = useRouter();
const state = reactive({


  rightData1Index: 0,

});

// 在 onMounted 中初始化地图
onMounted(() => {});
function tabClick(index) {
  state.rightData1Index = index;
}
// 返回上一页
function clickReturn() {
  router.go(-1);
}

onUnmounted(() => {});
onBeforeUnmount(() => {
  // clearInterval(timer.value);
});
</script>

<style scoped lang="less">
.whole_bg {
  width: 100%;
  height: 100%;
  background-color: #030a0c;
}
.big_bt {
  width: 100%;
  height: 90px;
}
.nr_txt {
  width: 100%;
  height: calc(100% - 120px);
  display: flex;
  .xiao_bt {
    width: 100%;
    height: 40px;
    font-size: 20px;
    font-weight: bold;
    color: #fff;
    text-align: left;
    text-indent: 2em;
    line-height: 20px;
    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/qqxm/xbt1.png")
    no-repeat 0% 100%;
  }
  .nr_txt_left {
    flex: 1;
    height: 100%;
    //border: #fff 1px solid;
    display: flex;
    flex-direction: column;

    .txt_left_top {
      width: 100%;
      height: 50%;
      display: flex;
      flex-direction: column;
      .left_top_dh {
        width: 100%;
        height: 56px;
        margin-top: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        .top_dh {
          width: 140px;
          height: 56px;
          margin: 0 13px;
          color: #fff;
          font-size: 16px;
          text-align: left;
          line-height: 56px;
          text-indent: 4em;
        }
        .top_dh1 {
          background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/qqxm/qj.png")
            no-repeat top center;
          background-size: 100% 100%;
        }
        .top_dh2 {
          background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/qqxm/zj.png")
            no-repeat top center;
          background-size: 100% 100%;
        }
        .top_dh3 {
          background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/qqxm/rj.png")
            no-repeat top center;
          background-size: 100% 100%;
        }
      }
      .left_top_txt {
        width: 100%;
        flex: 1;
      }
    }
    .txt_left_down {
      width: 100%;
      height: 50%;
      display: flex;
      flex-direction: column;
      .left_down_txt{
        width: 100%;
        flex: 1;
      }
    }
  }
  .nr_txt_mid {
    width: 860px;
    height: 100%;
    //border: #fff 1px solid;
    .dt{
      width: 100%;
      height: 734px;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .nr_txt_right {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    //border: #fff 1px solid;
    .txt_right_top{
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;

    }
    .txt_right_down{
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
    }
    .right_nr{
      flex: 1;
      width: 100%;
    }
  }
}
</style>
